// Considered: `SphereAvatar` (glyph-based, `sphere-avatar.md`) — rejected. That standard governs
// SPHERE avatars read exclusively via `globalSphereCache`; actors rendered in the Stream are
// IDENTITIES (people), not spheres, and calling `getSignedSphereImage` from here is exactly what
// the standard forbids. This atom derives initials only — no image fetch.
// See spec Reuse Audit (specs/stream-trajectory-tools.md).
//
// Source: design/metaspace-tools/metaspace-tools-v2.jsx:36-38 (`MSAva`).

import React from 'react';
import './InitialsAvatarAtom.scss';

export interface InitialsAvatarAtomProps {
  /** Display name to derive initials from. */
  name: string;
  size?: number;
  className?: string;
}

/**
 * Derives up to two initials from a display name: first letter of the first two
 * whitespace-separated words. A single-word name yields one letter; an empty/unknown
 * name yields "?" rather than throwing.
 */
export function deriveInitials(name: string): string {
  const words = name.trim().split(/\s+/).filter(Boolean);
  if (words.length === 0) return '?';
  const initials = words.slice(0, 2).map((w) => [...w][0]?.toUpperCase() ?? '');
  return initials.join('') || '?';
}

const InitialsAvatarAtom: React.FC<InitialsAvatarAtomProps> = ({ name, size = 20, className }) => {
  const initials = deriveInitials(name);
  return (
    <span
      className={['initials-avatar-atom', className].filter(Boolean).join(' ')}
      style={{ width: size, height: size, fontSize: size * 0.4 }}
      aria-hidden="true"
    >
      {initials}
    </span>
  );
};

InitialsAvatarAtom.displayName = 'InitialsAvatarAtom';

export default InitialsAvatarAtom;
